// GENERATED AUTOMATICALLY
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntdIcon, { AntdIconProps } from '../components/AntdIcon';
import { IconDefinition } from '../types';

const HelpOutlinedSvg: IconDefinition = {"icon":{"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","focusable":"false"},"children":[{"tag":"g","attrs":{"clip-path":"url(#clip0_123_2387)"},"children":[{"tag":"path","attrs":{"d":"M11 18h2v-2h-2v2zm1-16a10 10 0 100 20 10 10 0 000-20zm0 18a8.01 8.01 0 010-16 8.01 8.01 0 010 16zm0-14a4 4 0 00-4 4h2c0-1.1.9-2 2-2a2 2 0 012 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5a4 4 0 00-4-4z","fill":"currentColor"}}]},{"tag":"defs","attrs":{},"children":[{"tag":"clipPath","attrs":{"id":"clip0_123_2387"},"children":[{"tag":"path","attrs":{"d":"M0 0h24v24H0z","fill":"currentColor"}}]}]}]},"name":"help","theme":"outlined"};

const HelpOutlined = (
  props: AntdIconProps,
  ref: React.MutableRefObject<HTMLSpanElement>,
) => <AntdIcon {...props} ref={ref} icon={HelpOutlinedSvg} />;
  HelpOutlined.displayName = 'HelpOutlined';

export default React.forwardRef<HTMLSpanElement, AntdIconProps>(HelpOutlined);
